import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=0c763008&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "@/styles/homes.less?vue&type=style&index=0&id=0c763008&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c763008",
  null
  
)

export default component.exports